import { render, staticRenderFns } from "./UserReadInfo.vue?vue&type=template&id=5a5f5098&scoped=true&"
import script from "./UserReadInfo.vue?vue&type=script&lang=js&"
export * from "./UserReadInfo.vue?vue&type=script&lang=js&"
import style0 from "./UserReadInfo.vue?vue&type=style&index=0&id=5a5f5098&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5f5098",
  null
  
)

export default component.exports